export default (event, link) => {
  if (!link) {
    return event.preventDefault();
  }
};
